<template>
    <div>
        <SudosuFrame />
        <CountryLaunchingBanner />
        <UnsubscribeInvitationBanner />
        <HeaderUnlogged v-if="$ff('new-unlogged-navbar')" />
        <NavbarUnlogged v-else :show-search="searchIsVisible" />
        <slot />
        <!-- Event when logged in, we want to display this footer -->
        <FooterUnlogged :always-visible="true" />

        <ClientOnly>
            <LazyHostRedirectionDialog v-if="!loggedIn" />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {FooterUnlogged, LazyHostRedirectionDialog, HeaderUnlogged, NavbarUnlogged, SudosuFrame} from '#components';
    import {useAuth} from '#imports';
    import CountryLaunchingBanner from '~/components/CountryLaunchingBanner.vue';
    import UnsubscribeInvitationBanner from '~/components/UnsubscribeInvitationBanner.vue';
    import {useHeaderSearchVisibility} from '~/composables/useHeaderSearchVisibility';

    const {searchIsVisible} = useHeaderSearchVisibility();

    const auth = useAuth();
    const {loggedIn} = storeToRefs(auth);
</script>
